export default __webpack_public_path__ + "static/media/sv-tv-logo.e8e49ba2.png";